(() => {
  const doc = document.documentElement;
  doc.classList.remove('no-js');
  doc.classList.add('js');

  const body = document.body;
  const header = document.querySelector('[data-site-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');

  const setHeaderState = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
  };
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      menu.classList.toggle('is-open', !isOpen);
      header?.classList.toggle('is-menu-active', !isOpen);
      body.classList.toggle('is-menu-open', !isOpen);
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      header?.classList.remove('is-menu-active');
      body.classList.remove('is-menu-open');
    }));
  }

  if (body.dataset.reveal === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealItems = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(item);
    });
  } else {
    document.querySelectorAll('.reveal').forEach((item) => item.classList.add('is-visible'));
  }

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterDrawer = document.querySelector('[data-filter-drawer]');
  if (filterToggle && filterDrawer) {
    filterToggle.addEventListener('click', () => {
      const isOpen = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', String(!isOpen));
      filterDrawer.classList.toggle('is-open', !isOpen);
    });
  }

  const filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.querySelectorAll('[data-filter-input]').forEach((input) => {
      input.addEventListener('change', () => filterForm.submit());
    });
    document.addEventListener('click', (event) => {
      filterForm.querySelectorAll('[data-filter-group][open]').forEach((group) => {
        if (!group.contains(event.target)) group.removeAttribute('open');
      });
    });
  }

  const inquiryDialog = document.querySelector('[data-inquiry-dialog]');
  const openInquiry = () => {
    if (!inquiryDialog) return;
    inquiryDialog.showModal();
    body.classList.add('is-dialog-open');
  };
  const closeInquiry = () => {
    inquiryDialog?.close();
    body.classList.remove('is-dialog-open');
  };
  document.querySelectorAll('[data-inquiry-open]').forEach((button) => button.addEventListener('click', openInquiry));
  inquiryDialog?.querySelector('[data-inquiry-close]')?.addEventListener('click', closeInquiry);
  inquiryDialog?.addEventListener('click', (event) => { if (event.target === inquiryDialog) closeInquiry(); });
  inquiryDialog?.addEventListener('close', () => body.classList.remove('is-dialog-open'));
  if (inquiryDialog?.querySelector('.form-success, .errors')) openInquiry();

  const lightbox = document.querySelector('[data-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
  document.querySelectorAll('[data-lightbox-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!lightbox || !lightboxImage) return;
      lightboxImage.src = button.dataset.imageSrc;
      lightbox.showModal();
      body.classList.add('is-dialog-open');
    });
  });
  const closeLightbox = () => {
    lightbox?.close();
    if (lightboxImage) lightboxImage.src = '';
    body.classList.remove('is-dialog-open');
  };
  lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
  lightbox?.addEventListener('close', () => body.classList.remove('is-dialog-open'));

  const privateRoom = document.querySelector('[data-private-room]');
  if (privateRoom?.dataset.gated === 'true') {
    const gate = privateRoom.querySelector('[data-private-gate]');
    const content = privateRoom.querySelector('[data-private-content]');
    const form = privateRoom.querySelector('[data-private-gate-form]');
    const error = privateRoom.querySelector('[data-private-gate-error]');
    const exitButton = privateRoom.querySelector('[data-private-exit]');
    const storageKey = 'ethosalis-private-access';
    const unlock = () => {
      gate?.remove();
      content?.classList.remove('is-locked');
      window.scrollTo({ top: 0, behavior: 'instant' });
    };
    if (sessionStorage.getItem(storageKey) === 'granted') unlock();
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const entered = form.querySelector('input')?.value.trim();
      if (entered && entered === privateRoom.dataset.accessCode) {
        sessionStorage.setItem(storageKey, 'granted');
        unlock();
      } else if (error) {
        error.hidden = false;
      }
    });
    exitButton?.addEventListener('click', () => {
      sessionStorage.removeItem(storageKey);
      window.location.reload();
    });
  }

  if (body.classList.contains('has-custom-cursor') && window.matchMedia('(pointer: fine)').matches) {
    const dot = document.querySelector('.cursor-dot');
    const ring = document.querySelector('.cursor-ring');
    let ringX = 0;
    let ringY = 0;
    let mouseX = 0;
    let mouseY = 0;
    window.addEventListener('mousemove', (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
      if (dot) dot.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
    }, { passive: true });
    const animateRing = () => {
      ringX += (mouseX - ringX) * 0.16;
      ringY += (mouseY - ringY) * 0.16;
      if (ring) ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      requestAnimationFrame(animateRing);
    };
    animateRing();
    document.querySelectorAll('a, button, summary, label, input, textarea, select').forEach((element) => {
      element.addEventListener('mouseenter', () => ring?.classList.add('is-active'));
      element.addEventListener('mouseleave', () => ring?.classList.remove('is-active'));
    });
  }
})();
